var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal_form_preview",attrs:{"title":`Form Preview: ${_vm.name}`,"stretch":""},scopedSlots:_vm._u([{key:"close-button",fn:function(){return [_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("\n            Close Preview\n        ")])]},proxy:true}])},[_c('content-header',{attrs:{"links":[
        {
            label: _vm.Pages.FORM,
            active: _vm.current_page === _vm.Pages.FORM,
            on_click: _vm.setCurrentPage,
            on_click_params: [_vm.Pages.FORM],
        },
        {
            label: _vm.Pages.PEOPLE,
            active: _vm.current_page === _vm.Pages.PEOPLE,
            on_click: _vm.setCurrentPage,
            on_click_params: [_vm.Pages.PEOPLE],
            hide: !_vm.form.add_operative_with_signature,
        },
        {
            label: _vm.Pages.SIGNATURE,
            active: _vm.current_page === _vm.Pages.SIGNATURE,
            on_click: _vm.setCurrentPage,
            on_click_params: [_vm.Pages.SIGNATURE],
            hide: !_vm.form.signature,
        },
        {
            label: _vm.Pages.IMAGES,
            active: _vm.current_page === _vm.Pages.IMAGES,
            on_click: _vm.setCurrentPage,
            on_click_params: [_vm.Pages.IMAGES],
            hide: !_vm.form.photos,
        },
        {
            label: _vm.Pages.COMMENTS,
            active: _vm.current_page === _vm.Pages.COMMENTS,
            on_click: _vm.setCurrentPage,
            on_click_params: [_vm.Pages.COMMENTS],
            hide: !_vm.form.additional_comments,
        },
    ]}}),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"formPreviewContent"}},[_c('modal-tab-content',{attrs:{"tab_name":"Form","selected":_vm.isActivePage(_vm.Pages.FORM)}},[_vm._l((_vm.form.questions),function(question){return _c('form-submittable-questions',{key:question.id,attrs:{"question":question,"request_form":_vm.request_form},on:{"update-value":_vm.updateValue}})})],2),_vm._v(" "),(_vm.form.add_operative_with_signature)?_c('modal-tab-content',{attrs:{"tab_name":"People","selected":_vm.isActivePage(_vm.Pages.PEOPLE)}},[[_c('form-submittable-people',{attrs:{"people":[
                        {
                            id: 1,
                            name: 'John Doe',
                            email: 'john.doe@underconstruction.co.uk',
                        },
                        {
                            id: 2,
                            name: 'Jane Doe',
                            email: 'jane.doe@underconstruction.co.uk',
                        },
                        {
                            id: 3,
                            name: 'John Smith',
                            email: 'john.smith@underconstruction.co.uk',
                        },
                        {
                            id: 4,
                            name: 'Jane Smith',
                            email: 'jane.smith@underconstruction.co.uk',
                        },
                    ]},on:{"update-value":_vm.updateValue}})]],2):_vm._e(),_vm._v(" "),(_vm.form.signature)?_c('modal-tab-content',{attrs:{"tab_name":"Signature","selected":_vm.isActivePage(_vm.Pages.SIGNATURE)}},[[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('form-submittable-signature',{ref:"signature-canvas",on:{"update-value":_vm.updateValue}})],1)]],2):_vm._e(),_vm._v(" "),(_vm.form.photos)?_c('modal-tab-content',{attrs:{"tab_name":"Images","selected":_vm.isActivePage(_vm.Pages.IMAGES)}},[[_c('form-submittable-images',{attrs:{"request_form":_vm.request_form},on:{"update-value":_vm.updateValue}})]],2):_vm._e(),_vm._v(" "),(_vm.form.additional_comments)?_c('modal-tab-content',{attrs:{"tab_name":"Comments","selected":_vm.isActivePage(_vm.Pages.COMMENTS)}},[[_c('form-submittable-comments',{attrs:{"request_form":_vm.request_form},on:{"update-value":_vm.updateValue}})]],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"w-100 btn btn-positive"},[_vm._v("Submit Form")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }